import { render, staticRenderFns } from "./acceptInvite.vue?vue&type=template&id=50b11cfa&scoped=true"
import script from "./acceptInvite.vue?vue&type=script&lang=js"
export * from "./acceptInvite.vue?vue&type=script&lang=js"
import style0 from "./acceptInvite.vue?vue&type=style&index=0&id=50b11cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b11cfa",
  null
  
)

export default component.exports